/**
 * Action for Fetch connector list details
 */
export enum getConnectorList {
  FETCH_CONNECTOR_LIST_REQUEST = 'FETCH_CONNECTOR_LIST_REQUEST',
}
